export const exportChatAsMarkdown = (messages, title = "Chat Export") => {
  let markdown = `# ${title}\n\n`;
  markdown += `Exported on: ${new Date().toLocaleString()}\n\n`;
  markdown += "---\n\n";

  messages.forEach((msg, index) => {
    const role = msg.role === "user" ? "User" : "Assistant";
    const timestamp = msg.timestamp
      ? new Date(msg.timestamp).toLocaleString()
      : "";
    
    markdown += `## ${role}${timestamp ? ` (${timestamp})` : ""}\n\n`;
    markdown += `${msg.content}\n\n`;
    markdown += "---\n\n";
  });

  return markdown;
};

export const exportChatAsJSON = (messages, title = "Chat Export") => {
  const data = {
    title,
    exportedAt: new Date().toISOString(),
    messageCount: messages.length,
    messages: messages.map((msg) => ({
      role: msg.role,
      content: msg.content,
      timestamp: msg.timestamp || new Date().toISOString(),
    })),
  };

  return JSON.stringify(data, null, 2);
};

export const downloadFile = (content, filename, mimeType = "text/plain") => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportChat = (messages, title, format = "markdown") => {
  let content, filename, mimeType;

  if (format === "markdown") {
    content = exportChatAsMarkdown(messages, title);
    filename = `${title.replace(/[^a-z0-9]/gi, "_")}.md`;
    mimeType = "text/markdown";
  } else if (format === "json") {
    content = exportChatAsJSON(messages, title);
    filename = `${title.replace(/[^a-z0-9]/gi, "_")}.json`;
    mimeType = "application/json";
  }

  downloadFile(content, filename, mimeType);
};








